import { Component, OnInit } from '@angular/core';
import { MemberDetails, MemberQuery } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-account-details-page',
  templateUrl: './account-details-page.component.html',
  styleUrls: ['./account-details-page.component.scss'],
})
export class AccountDetailsPageComponent implements OnInit {
  
  member$: Observable<MemberDetails | undefined>;
  constructor(private memberQuery: MemberQuery) {}

  ngOnInit() {
    this.member$ = this.memberQuery.selectMemberDetails();
}
}
